import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';

// 加载插件
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);

// 设置默认语言为中文
dayjs.locale('zh-cn');

// 设置默认时区为东八区（北京时间）
dayjs.tz.setDefault('Asia/Shanghai');

// 创建增强的 dayjs 实例
const tzDayjs = (...args) => {
  // 如果没有参数，返回当前时间的东八区时间
  if (args.length === 0) {
    return dayjs().tz();
  }
  // 如果有参数，转换为东八区时间
  return dayjs(...args).tz();
};

// 复制所有 dayjs 方法
Object.assign(tzDayjs, dayjs);

// 添加常用格式化方法
tzDayjs.getCurrentDateTime = () => {
  return tzDayjs().format('YYYY-MM-DDTHH:mm:ss');
};

tzDayjs.getCurrentDate = () => {
  return tzDayjs().format('YYYY-MM-DD');
};

tzDayjs.getCurrentTime = () => {
  return tzDayjs().format('HH:mm:ss');
};

tzDayjs.getCurrentTimestamp = () => {
  return tzDayjs().valueOf();
};

tzDayjs.getCurrentUnix = () => {
  return tzDayjs().unix();
};

// 格式化函数
tzDayjs.formatDateTime = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  return tzDayjs(date).format(format);
};

tzDayjs.formatDate = (date) => {
  return tzDayjs(date).format('YYYY-MM-DD');
};

tzDayjs.formatTime = (date) => {
  return tzDayjs(date).format('HH:mm:ss');
};

// 相对时间
tzDayjs.fromNow = (date) => {
  return tzDayjs(date).fromNow();
};

tzDayjs.toNow = (date) => {
  return tzDayjs(date).toNow();
};

// 获取一天的开始和结束
tzDayjs.startOfDay = (date = null) => {
  const d = date ? tzDayjs(date) : tzDayjs();
  return d.startOf('day').format('YYYY-MM-DD HH:mm:ss');
};

tzDayjs.endOfDay = (date = null) => {
  const d = date ? tzDayjs(date) : tzDayjs();
  return d.endOf('day').format('YYYY-MM-DD HH:mm:ss');
};

// 时区转换
tzDayjs.toTimezone = (date, timezone) => {
  return tzDayjs(date).tz(timezone);
};

tzDayjs.getTimezone = () => {
  return dayjs.tz.guess();
};

tzDayjs.formatDuration = (startTime) => {
  if (!startTime) return ''
  const start = new Date(startTime)
  const now = new Date()
  const diffMs = now - start
  const hours = Math.floor(diffMs / 3600000)
  const minutes = Math.floor((diffMs % 3600000) / 60000)
  return `${hours}小时${minutes}分钟`
}

export default tzDayjs;